import { render, staticRenderFns } from "./OrderDetailsModal.vue?vue&type=template&id=34863a1d&scoped=true&"
import script from "./OrderDetailsModal.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailsModal.vue?vue&type=style&index=0&id=34863a1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34863a1d",
  null
  
)

export default component.exports